module.exports = __webpack_public_path__ + "img/cp-admin.37107738.svg";